/**
 * Created by mongoose on 6/08/16.
 */
/* eslint-disable*/
import { parseDateOrNull, addDays, parseIntOrNull, dateDiffInDays } from "../../utils/date";
import constants from "../../utils/constants";
import { requestPropertyData, requestConfiguration, requestARI } from "../../utils/witbookingApi";
import { changeLocale as changeLocaleIntl } from "~/redux/modules/intl";
import {
  getFromLocalStorage,
  saveToLocalStorage,
  getFromSessionStorage,
  saveToSessionStorage,
  removeUndefinedOrNullProps,
} from "../../utils/misc";
import moment from "moment";
import uniq from "lodash/uniq";
import Bowser from "bowser";
import { init as initEngineDataCollector } from "../../utils/EngineDataColllector/EngineDataCollector";
import { getIPInfo } from "../../utils/EngineDataColllector/IPCollector";
import { getSessionData } from "../../utils/session";

// Loop through occupant types in descending order by age category
// seniors adults teenagers children babies
// For each occupant types
// Check if there is a max value , if so the engine accepts that type
// if there is a maxValue for the currentType
//  get its min age and put that value in currentMaxAge (if there's no minAge throw ERROR)
//  build range where maxValue is currentMaxAge minus 1 and minValue is minValue
// if there is not a maxValue for the currentType
//  continue loop
export function buildAgeRanges(occupantsMaxValues, occupantsMinAge, types) {
  /* TODO: what if occupantsMaxValues and occupantsMinAge are immutable??? */
  const ageRanges = {};
  // When there's no occupation filter, there are no ages because all occupants are of the same type, so we return no range.
  if (!occupantsMinAge || Object.keys(occupantsMinAge).length === 0) {
    return null;
  }
  let currentMaxAge = 1000;
  types.forEach(type => {
    if (!(occupantsMaxValues.hasOwnProperty(type) && occupantsMaxValues[type] > 0)) {
      return undefined;
    }
    if (
      !(
        occupantsMinAge.hasOwnProperty(type) &&
        typeof occupantsMinAge[type] !== "undefined" &&
        occupantsMinAge[type] !== null
      )
    ) {
      console.log(`BAD ENGINE CONFIGURATION. ACCEPTS type ${type} but there is no Min Age value `);
      return undefined;
    }
    ageRanges[type] = { max: currentMaxAge - 1, min: occupantsMinAge[type] };
    currentMaxAge = occupantsMinAge[type];
  });
  return ageRanges;
}

function getBooleanParam(value) {
  if (value) {
    return value === "1";
  }

  return false;
}

function getShowHideParam(iframeMode, show, externalShow) {
  let result = true;
  /*TODO: test this*/
  if (show) {
    result = show === "1" || show === "2" || show === "3";
  } else if (iframeMode) {
    result = false;
  } else {
    result = externalShow;
  }

  return result;
}

function getFullWidthType(fullWidthValue) {
  if (!fullWidthValue) {
    return null;
  }
  switch (fullWidthValue) {
    case "1":
      return constants.FULL_WIDTH_TYPE.FLOATING_MAP;
    case "2":
      return constants.FULL_WIDTH_TYPE.FIXED_MINIFORM;
    case "3":
      return constants.FULL_WIDTH_TYPE.FLOATING_MAP;
    default:
      return null;
  }
}

function getOccupantSelectorRange(params) {
  let result = null;

  if (params) {
    result = params.split(",");
    result = result && result.map(value => parseInt(value, 10));
  }

  return result;
}

function getOccupantValue(occupantSelectorRange, occupantDefaultValue) {
  return (
    (occupantSelectorRange &&
      occupantSelectorRange.indexOf(occupantDefaultValue) === -1 &&
      occupantSelectorRange[0]) ||
    occupantDefaultValue
  );
}

function parseStartDate(startDate) {
  if (startDate && startDate.includes("offset_")) {
    const numberOfDays = parseIntOrNull(startDate.split("_")[1]);
    if (numberOfDays !== null) {
      return moment().startOf("day").add(numberOfDays, "days").toDate();
    }
  }
  return parseDateOrNull(startDate);
}

function mapDeviceType(deviceType) {
  const matchIosSafari =
    ["iPhone Simulator", "iPod Simulator", "iPhone", "iPod"].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
    navigator.userAgent.match(/iPhone/);

  if (matchIosSafari) {
    return constants.DEVICE_TYPE.MOBILE;
  }

  const matchIpadSafari =
    ["iPad Simulator", "iPad"].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
    navigator.userAgent.match(/iPad/);

  if (matchIpadSafari) {
    return constants.DEVICE_TYPE.TABLET;
  }

  switch (deviceType) {
    case "desktop":
      return constants.DEVICE_TYPE.DESKTOP;
    case "mobile":
      return constants.DEVICE_TYPE.MOBILE;
    case "tablet":
      return constants.DEVICE_TYPE.TABLET;
    default:
      return constants.DEVICE_TYPE.DESKTOP;
  }
}

// build external tracker configuration
// e.g. metasearch like TRIVAGO / TRIPADVISOR
function buildTrackerInfo(urlParams, externalConfiguration) {
  const tracking = [];
  switch (urlParams.channel) {
    case constants.METASEARCH.TRIVAGO: {
      tracking.push({
        tracker: constants.METASEARCH.TRIVAGO,
        trackerReference: urlParams.trv_reference,
      });
      break;
    }
    default:
      break;
  }
  return tracking;
}

function isDefaultQuery(urlParams) {
  const hasOccupants =
    urlParams.seniors ||
    urlParams.adults ||
    urlParams.adultos ||
    urlParams.teenagers ||
    urlParams.children ||
    urlParams.ninos ||
    urlParams.babies ||
    urlParams.bebes ||
    urlParams.personas;
  const hasDates =
    urlParams.datein ||
    urlParams.fini ||
    urlParams.nights ||
    urlParams.noches ||
    urlParams.dateout ||
    urlParams.fout;

  return Boolean(hasOccupants) || Boolean(hasDates);
}

// build configuration object for the whole app
// based on the params received
// and put it in the store
function buildConfiguration({ urlParams, ipInfo, sessionData = {} }) {
  const configuration = {};
  const localStorageParams =
    (getFromLocalStorage(constants.LOCAL_STORAGE_KEYS.ARI_REQUEST_PARAMS) &&
      getFromLocalStorage(constants.LOCAL_STORAGE_KEYS.ARI_REQUEST_PARAMS)["params"]) ||
    {};
  const propertySessionStorageParams =
    (getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS) &&
      getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS)[
        urlParams.hotelTicker
      ]) ||
    {};
  const storedCurrency = getFromLocalStorage(constants.LOCAL_STORAGE_KEYS.CURRENCY);
  configuration.hotelTicker = urlParams.hotelTicker;
  configuration.locale =
    urlParams.locale || urlParams.lang || urlParams.language || localStorageParams.locale;

  /* TODO: get configuration values from API*/
  return requestConfiguration({}, { propertyTicker: configuration.hotelTicker })
    .then(externalConfiguration => {
      /* TODO: validate criteria*/
      if (urlParams.inventoryGroupingCriteria) {
        if (urlParams.inventoryGroupingCriteria === "none") {
          configuration.inventoryGroupingCriteria = [];
        } else {
          configuration.inventoryGroupingCriteria = Array.isArray(
            urlParams.inventoryGroupingCriteria
          )
            ? urlParams.inventoryGroupingCriteria
            : [urlParams.inventoryGroupingCriteria];
        }
      } else if (externalConfiguration.inventoryGroupingCriteria) {
        if (externalConfiguration.inventoryGroupingCriteria === "none") {
          configuration.inventoryGroupingCriteria = [];
        } else {
          configuration.inventoryGroupingCriteria = Array.isArray(
            externalConfiguration.inventoryGroupingCriteria
          )
            ? externalConfiguration.inventoryGroupingCriteria
            : [externalConfiguration.inventoryGroupingCriteria];
        }
      }
      /* ----------------------------FULL_WIDTH---------------------------------*/
      configuration.fullWidth = true;
      configuration.fullWidthType =
        getFullWidthType(urlParams.fullWidth) || constants.FULL_WIDTH_TYPE.FLOATING_MAP;
      /* ----------------------------END_FULL_WIDTH-----------------------------*/

      /* ----------------------------PARSE_LOCALE-----------------------------*/
      /*  TODO: Implement this logic on the API */
      /*  if no locale is specified we set the property's default locale */
      if (externalConfiguration.availableLocales.indexOf(configuration.locale) === -1) {
        configuration.locale = externalConfiguration.defaultLocale;
      }
      /* ----------------------------END_PARSE_LOCALE-----------------------------*/

      /* ----------------------------PARSE_START_DATE-----------------------------*/
      configuration.startDate =
        parseStartDate(urlParams.datein || urlParams.fini) ||
        (localStorageParams.start && moment(localStorageParams.start).toDate()) ||
        new Date();
      if (dateDiffInDays(new Date(), configuration.startDate) <= 0) {
        configuration.startDate = new Date();
      }
      /* --------------------------END_PARSE_START_DATE---------------------------*/

      /* ----------------------------PARSE_END_DATE-----------------------------*/
      configuration.endDate = parseDateOrNull(urlParams.dateout || urlParams.fout);
      if (!configuration.endDate && (urlParams.nights || urlParams.noches)) {
        configuration.endDate = addDays(
          configuration.startDate,
          parseIntOrNull(urlParams.nights || urlParams.noches) || 1
        );
      }
      if (!configuration.endDate) {
        configuration.endDate =
          (localStorageParams.end && moment(localStorageParams.end).toDate()) ||
          addDays(configuration.startDate, 1);
      }
      if (
        dateDiffInDays(configuration.startDate, configuration.endDate) >
          externalConfiguration.maxBookableNights ||
        dateDiffInDays(configuration.startDate, configuration.endDate) < 1
      ) {
        configuration.endDate = addDays(configuration.startDate, 1);
      }
      /* -------------------------- END_PARSE_END_DATE ---------------------------*/

      /* ---------------------------- PARSE_OCCUPANTS ---------------------------------*/
      if (
        urlParams.seniors ||
        urlParams.adults ||
        urlParams.adultos ||
        urlParams.teenagers ||
        urlParams.children ||
        urlParams.ninos ||
        urlParams.babies ||
        urlParams.bebes ||
        urlParams.personas
      ) {
        configuration[constants.OCCUPANTS_TYPE.SENIOR] = parseIntOrNull(urlParams.seniors) || 0;
        configuration[constants.OCCUPANTS_TYPE.TEENAGER] = parseIntOrNull(urlParams.teenagers) || 0;
        configuration[constants.OCCUPANTS_TYPE.CHILDREN] =
          parseIntOrNull(urlParams.children || urlParams.ninos) || 0;
        configuration[constants.OCCUPANTS_TYPE.BABY] =
          parseIntOrNull(urlParams.babies || urlParams.bebes) || 0;

        if (urlParams.adults || urlParams.adultos) {
          configuration[constants.OCCUPANTS_TYPE.ADULT] =
            urlParams.adults === "*"
              ? "*"
              : parseIntOrNull(urlParams.adults || urlParams.adultos) ||
                localStorageParams.adults ||
                2;
        } else {
          configuration[constants.OCCUPANTS_TYPE.ADULT] = parseIntOrNull(urlParams.personas) || 2;
        }
      } else {
        configuration[constants.OCCUPANTS_TYPE.SENIOR] = localStorageParams.seniors || 0;
        configuration[constants.OCCUPANTS_TYPE.ADULT] = localStorageParams.adults || 2;
        configuration[constants.OCCUPANTS_TYPE.TEENAGER] = localStorageParams.teenagers || 0;
        configuration[constants.OCCUPANTS_TYPE.CHILDREN] = localStorageParams.children || 0;
        configuration[constants.OCCUPANTS_TYPE.BABY] = localStorageParams.babies || 0;
      }

      /*  Set guestAges into their corresponding Buckets */
      /*  TODO: THIS FAILS WHEN A GIVEN AGE CORRESPONDS TO AN ADULT!!! IN that case, we should remove this guest age add +1 to adults and keep the rest. THis could happen on chain hotels with different child ranges*/
      configuration.guestAges = null;
      configuration.ageRanges = buildAgeRanges(
        externalConfiguration.occupantsMaxValues,
        externalConfiguration.occupantsMinAge,
        constants.OCCUPANTS_TYPE_ORDER
      );

      if (
        externalConfiguration.filterGuestsByAge &&
        urlParams.guestAges &&
        urlParams.guestAges.length > 0
      ) {
        if (typeof urlParams.guestAges === "string") {
          configuration.guestAges = urlParams.guestAges
            .split(",")
            .map(parseIntOrNull)
            .filter(age => age !== null);
        } else {
          configuration.guestAges = urlParams.guestAges
            .map(parseIntOrNull)
            .filter(age => age !== null);
        }
      }
      /* TODO : WHAT ABOUT NONE FILTER*/
      configuration.occupantsFilterType = externalConfiguration.filterGuestsByAge
        ? constants.OCCUPANTS_FILTER_TYPE.AGE
        : constants.OCCUPANTS_FILTER_TYPE.OCCUPANTS_TYPE;

      /* ----------------------------END_PARSE_OCCUPANTS-----------------------------*/

      /* ----------------------------PARSE_FILTERS-----------------------------*/
      configuration.il_clean = urlParams.il_clean && urlParams.il_clean === "1";
      if (!configuration.il_clean) {
        configuration.il_equal = urlParams.il_equal || null;
        configuration.il_like = urlParams.il_like || null;
      }
      /* ----------------------------END_PARSE_FILTERS-----------------------------*/

      /* ----------------------------PARSE_CURRENCY-----------------------------*/
      configuration.currency =
        storedCurrency ||
        (urlParams.setconversion &&
        externalConfiguration.availableCurrencies.indexOf(urlParams.setconversion.toUpperCase()) >=
          0
          ? urlParams.setconversion.toUpperCase()
          : externalConfiguration.defaultCurrency);
      /* ----------------------------END_PARSE_CURRENCY-----------------------------*/

      /* ----------------------------PARSE_PROMO_CODE-----------------------------*/
      configuration.prom_clean = urlParams.prom_clean && urlParams.prom_clean === "1";
      configuration.promoCodes = "";

      configuration.promoCodes =
        (urlParams.prom && [...configuration.promoCodes, ...urlParams.prom.split(",")]) ||
        configuration.promoCodes;
      configuration.promoCodes =
        (urlParams.cod_tarifa && [
          ...configuration.promoCodes,
          ...urlParams.cod_tarifa.split(","),
        ]) ||
        configuration.promoCodes;
      configuration.promoCodes =
        (urlParams.promotionalcode && [
          ...configuration.promoCodes,
          ...urlParams.promotionalcode.split(","),
        ]) ||
        configuration.promoCodes;
      configuration.promoCodes =
        (urlParams.fcod_rate && [...configuration.promoCodes, ...urlParams.fcod_rate.split(",")]) ||
        configuration.promoCodes;

      if (!configuration.prom_clean) {
        configuration.promoCodes =
          (propertySessionStorageParams.promoCodes && [
            ...configuration.promoCodes,
            ...propertySessionStorageParams.promoCodes,
          ]) ||
          configuration.promoCodes;
      }

      configuration.promoCodes = uniq(configuration.promoCodes).join(",");

      /* --------------------------END_PARSE_PROMO_CODE---------------------------*/

      /* ----------------------------EXPAND_BOOKABLES-----------------------------*/
      configuration.expandedBookables = urlParams.expand || null;
      /* ----------------------------END_EXPAND_BOOKABLES-----------------------------*/

      configuration.propertyTickers = (urlParams.hotel && urlParams.hotel.split(",")) || null;
      if (!configuration.propertyTickers) {
        configuration.propertyTickers = (urlParams.hotels && urlParams.hotels.split(",")) || null;
      }
      // TODO: legacy, this must be removed from all the application
      configuration.iframeMode = false;
      configuration.showDesktopLogo = getShowHideParam(
        configuration.iframeMode,
        urlParams.showDesktopLogo,
        externalConfiguration.showDesktopLogo
      );
      configuration.showMobileLogo = getShowHideParam(
        configuration.iframeMode,
        urlParams.showMobileLogo,
        externalConfiguration.showMobileLogo
      );
      configuration.showCurrencySelector = getShowHideParam(
        configuration.iframeMode,
        urlParams.showCurrency,
        externalConfiguration.showCurrencySelector
      );
      configuration.showLanguageSelector = getShowHideParam(
        configuration.iframeMode,
        urlParams.showLanguage,
        externalConfiguration.showLanguageSelector
      );
      configuration.showBookingForm = getShowHideParam(
        configuration.iframeMode,
        urlParams.showBookingForm,
        externalConfiguration.showBookingForm
      );
      configuration.showPromos = getShowHideParam(
        configuration.iframeMode,
        urlParams.showPromos,
        externalConfiguration.showPromos
      );
      configuration.showPropertyMap = getShowHideParam(
        configuration.iframeMode,
        urlParams.showPropertyMap,
        externalConfiguration.showPropertyMap
      );
      configuration.showDiscountMobile =
        (urlParams.showDiscountMobile && urlParams.showDiscountMobile === "1") ||
        externalConfiguration.showPromos;
      configuration.showCalendarByUrl =
        urlParams.showCalendar !== undefined && urlParams.showCalendar !== "0";
      configuration.showCalendar =
        urlParams.showCalendar !== "0" || externalConfiguration.showCalendar === true;
      configuration.channel = urlParams.channel || null;
      configuration.view = urlParams.view || null;
      configuration.tracking_id = urlParams.tracking_id || null;
      configuration.affiliateIsEncoded = !!urlParams.encodedAffiliate;
      configuration.encodedAffiliate = urlParams.encodedAffiliate;
      configuration.affiliate =
        atob(urlParams.encodedAffiliate || "") ||
        urlParams.affiliate ||
        urlParams.witaffiliate ||
        propertySessionStorageParams.affiliate ||
        urlParams.channel ||
        null;
      window.wbkAffiliate = configuration.affiliate;
      configuration.referrer = propertySessionStorageParams.referrer || null;
      if (urlParams.tab) {
        configuration.selectedTab = urlParams.tab;
      }
      configuration.activeFilters = urlParams.activeFilters && urlParams.activeFilters.split(";");
      configuration.showBookingOptionSummary = urlParams.showBookingOptionSummary
        ? getBooleanParam(urlParams.showBookingOptionSummary)
        : externalConfiguration.showBookingOptionSummary;
      configuration.roomRepresentationType =
        (urlParams.roomRepresentationType === "horizontal" &&
          constants.ROOM_REPRESENTATION_TYPE.HORIZONTAL) ||
        (urlParams.roomRepresentationType === "carousel" &&
          constants.ROOM_REPRESENTATION_TYPE.CAROUSEL) ||
        externalConfiguration.roomRepresentationType;
      configuration.roomDetailRepresentationType =
        (urlParams.roomDetailRepresentationType === "full" &&
          constants.ROOM_DETAIL_REPRESENTATION_TYPE.FULL) ||
        (urlParams.roomDetailRepresentationType === "embedded" &&
          constants.ROOM_DETAIL_REPRESENTATION_TYPE.EMBEDDED) ||
        externalConfiguration.roomDetailRepresentationType;
      configuration.showMenu =
        (urlParams.showMenu === undefined && true) ||
        getShowHideParam(
          configuration.iframeMode,
          urlParams.showMenu,
          externalConfiguration.showMenu
        );
      configuration.withotel = urlParams.withotel;
      configuration.origin =
        urlParams.origin || urlParams.busquedaOrigen || propertySessionStorageParams.origin;
      window.wbkOrigin = configuration.origin;

      configuration.mode = urlParams.mode || propertySessionStorageParams.mode;
      window.wbkMode = configuration.mode;

      configuration.customPropertyName =
        urlParams.busquedahotelNom || propertySessionStorageParams.customPropertyName;

      configuration.showDiscountsCalculation = urlParams.showDiscountsCalculation
        ? getBooleanParam(urlParams.showDiscountsCalculation)
        : externalConfiguration.showDiscountsCalculation;
      configuration.showInactiveDiscounts = urlParams.showInactiveDiscounts
        ? getBooleanParam(urlParams.showInactiveDiscounts)
        : externalConfiguration.showInactiveDiscounts;
      configuration.servicesCollapsed =
        urlParams.servicesCollapsed || externalConfiguration.servicesCollapsed;

      /** Custom occupant selectors **/
      configuration.seniorSelectorRange = getOccupantSelectorRange(
        urlParams.seniorSelectorRange || externalConfiguration.seniorSelectorRange
      );

      configuration.adultSelectorRange = getOccupantSelectorRange(
        urlParams.adultSelectorRange || externalConfiguration.adultSelectorRange
      );

      configuration.teenagerSelectorRange = getOccupantSelectorRange(
        urlParams.teenagerSelectorRange || externalConfiguration.teenagerSelectorRange
      );

      configuration.childSelectorRange = getOccupantSelectorRange(
        urlParams.childSelectorRange || externalConfiguration.childSelectorRange
      );

      configuration.babySelectorRange = getOccupantSelectorRange(
        urlParams.babySelectorRange || externalConfiguration.babySelectorRange
      );
      /** end **/

      /** Occupant values **/
      configuration[constants.OCCUPANTS_TYPE.SENIOR] = getOccupantValue(
        configuration.seniorSelectorRange,
        configuration[constants.OCCUPANTS_TYPE.SENIOR]
      );

      configuration[constants.OCCUPANTS_TYPE.ADULT] = getOccupantValue(
        configuration.adultSelectorRange,
        configuration[constants.OCCUPANTS_TYPE.ADULT]
      );

      configuration[constants.OCCUPANTS_TYPE.TEENAGER] = getOccupantValue(
        configuration.teenagerSelectorRange,
        configuration[constants.OCCUPANTS_TYPE.TEENAGER]
      );

      configuration[constants.OCCUPANTS_TYPE.CHILDREN] = getOccupantValue(
        configuration.childSelectorRange,
        configuration[constants.OCCUPANTS_TYPE.CHILDREN]
      );

      configuration[constants.OCCUPANTS_TYPE.BABY] = getOccupantValue(
        configuration.babySelectorRange,
        configuration[constants.OCCUPANTS_TYPE.BABY]
      );
      /** end **/

      configuration.propertySelectionBehavior =
        urlParams.propertySelectionBehavior || externalConfiguration.propertySelectionBehavior;
      configuration.accommodationSelectionBehavior =
        urlParams.accommodationSelectionBehavior ||
        externalConfiguration.accommodationSelectionBehavior;
      configuration.openCalendar =
        urlParams.openCalendar && getBooleanParam(urlParams.openCalendar);

      configuration.unavailableURL =
        urlParams.unavailableURL || externalConfiguration.unavailableURL || null;
      configuration.messageCode = urlParams.messageCode || null;
      configuration.cookieConsent =
        (urlParams.cookieConsent && parseInt(urlParams.cookieConsent, 10)) || null;
      configuration.displayElement = urlParams.displayElement || null;
      configuration.isAgent = urlParams.isAgent || null;
      configuration.showAgentLogin = urlParams.showAgentLogin || false;
      configuration.hasPremiumMap =
        urlParams.hasPremiumMap || externalConfiguration.hasPremiumMap || false;
      configuration.hideDefaultPrivacyPolicy =
        urlParams.hideDefaultPrivacyPolicy || externalConfiguration.hideDefaultPrivacyPolicy;
      configuration.roomSelectionViewType =
        urlParams.roomSelectionViewType || externalConfiguration.roomSelectionViewType || null;
      configuration.hideObligatoryExtras =
        urlParams.hideObligatoryExtras || externalConfiguration.hideObligatoryExtras;
      configuration.showBestPriceGuaranteed =
        urlParams.showBestPriceGuaranteed || externalConfiguration.showBestPriceGuaranteed;
      // TODO: if we migrate to SSR this may need to be removed as window
      // might not be available
      if (window) {
        const rawDeviceInfo = Bowser.parse(window.navigator.userAgent) || {};

        configuration.deviceInfo = {
          browserName: rawDeviceInfo.browser && rawDeviceInfo.browser.name,
          browserVersion: rawDeviceInfo.browser && rawDeviceInfo.browser.version,
          osName: rawDeviceInfo.os && rawDeviceInfo.os.name,
          osVersion: rawDeviceInfo.os && rawDeviceInfo.os.version,
          deviceType: mapDeviceType(rawDeviceInfo.platform && rawDeviceInfo.platform.type),
          deviceVendor: rawDeviceInfo.platform && rawDeviceInfo.platform.vendor,
          deviceModel: rawDeviceInfo.platform && rawDeviceInfo.platform.model,
          browserEngineName: rawDeviceInfo.engine && rawDeviceInfo.engine.name,
          browserEngineVersion: rawDeviceInfo.engine && rawDeviceInfo.engine.version,
        };
        //FIXME: REMOVE WHEN MIGRATION OVER
        window.showCancelMsg = externalConfiguration.showCancelMsg;
      }

      configuration.trackerInfo = buildTrackerInfo(urlParams, externalConfiguration);

      configuration.isSharedBooking = urlParams.isSharedBooking === "1";

      /* ----------------------------DATALAYER-----------------------------*/
      configuration.tacurrency = urlParams.tacurrency;
      configuration.tabr = urlParams.tabr;
      configuration.tatf = urlParams.tatf;
      configuration.tapi = urlParams.tapi;
      configuration.externalHotelId =
        urlParams.externalHotelId || externalConfiguration.externalHotelId;
      configuration.customOrigin = urlParams.customOrigin;
      /* ----------------------------SHOW_OCCUPATION_ALTERNATIVES-----------------------------*/
      configuration.showOccupationAlternatives =
        urlParams.showOccupationAlternatives || externalConfiguration.showOccupationAlternatives;
      /* ----------------------------END_SHOW_OCCUPATION_ALTERNATIVES-----------------------------*/
      /* ----------------------------SHOW_MULTIPLES_ACCOMMODATIONS-----------------------------*/
      configuration.showMultipleAccommodations = externalConfiguration.showMultipleAccommodations;
      /* ----------------------------END_SHOW_MULTIPLES_ACCOMMODATIONS-----------------------------*/
      /* ----------------------------SHOW_NEW_BOOKING_FORM-----------------------------*/
      // TO-DO remove this when api will be ready
      configuration.showNewBookingForm = externalConfiguration.showNewBookingForm;
      /* ----------------------------SHOW_NEW_BOOKING_FORM-----------------------------*/

      configuration.isDefaultQuery = isDefaultQuery(urlParams);
      /* ----------------------------IP Info-----------------------------*/
      configuration.ipInfo = { ...ipInfo };
      /* ----------------------------End IP Info-----------------------------*/
      configuration.maxCartItems =
        parseIntOrNull(urlParams.maxCartItems) ||
        sessionData.maxCartItems ||
        externalConfiguration.maxCartItems ||
        0;

      configuration.sessionId = urlParams.session;
      configuration.tags = urlParams.tags;

      configuration.promotionsListMode = externalConfiguration.promotionsListMode;
      /*  TODO: how do we handle session here? how do we get previous values ? The problem being
       * how do we handle when an user makes a query, the just refreshes the page? do we want to?
       * we should ONLY get data from session or local storage if there are no params
       * is that a common occurrence? What we could do, is to store a config in the server and then
       * request it from the client? is that universal? that does not make sense :( */
      /* Properties taken DIRECTLY from the externalConfiguration object*/
      return { ...externalConfiguration, ...configuration };
    })
    .catch(err => {
      console.log("An error ocurred getting the configuration3 " + err);
      throw err;
    });
}

export function fetchPropertyData(propertyTicker, locale, sessionId) {
  return requestPropertyData({}, { propertyTicker, locale, sessionId });
}

export function fetchARI(propertyTicker, params) {
  return requestARI({}, { propertyTicker, ...params });
}

export function buildARIRequestParams(configuration) {
  const deviceInfo = configuration.deviceInfo || {};
  const children =
    configuration[constants.OCCUPANTS_TYPE_COUNT.CHILDREN] ||
    configuration[constants.OCCUPANTS_TYPE.CHILDREN];
  return {
    localStorage: {
      seniors: configuration[constants.OCCUPANTS_TYPE.SENIOR],
      adults: configuration[constants.OCCUPANTS_TYPE.ADULT],
      teenagers: configuration[constants.OCCUPANTS_TYPE.TEENAGER],
      children: children,
      babies: configuration[constants.OCCUPANTS_TYPE.BABY],
      guestAges: configuration.guestAges,
      locale: configuration.locale,
      start: configuration.startDate,
      end: configuration.endDate,
      deviceInfo,
      sessionId: configuration.sessionId,
    },
    sessionStorage: {
      promoCodes: (configuration.promoCodes && configuration.promoCodes.split(",")) || null,
      inventoryTickersLikeFilter:
        (configuration.il_like &&
          configuration.il_like.replace(new RegExp(";", "g"), ",").split(",")) ||
        null,
      inventoryTickersEqualFilter:
        (configuration.il_equal &&
          configuration.il_equal.replace(new RegExp(";", "g"), ",").split(",")) ||
        null,
      ignoredConfiguration: configuration.ignoredConfiguration || false,
      propertyTickers: configuration.propertyTickers,
      affiliate: configuration.affiliate,
      referrer: configuration.referrer,
      channel: configuration.channel,
      origin: configuration.origin,
      customPropertyName: configuration.customPropertyName,
      mode: configuration.mode,
    },
  };
}

export function saveAriParamsToStorage(configuration, propertyTicker) {
  const ARIRequestParams = buildARIRequestParams(configuration);
  // We store the params of the first request
  saveToLocalStorage(constants.LOCAL_STORAGE_KEYS.ARI_REQUEST_PARAMS, {
    ["params"]: ARIRequestParams && ARIRequestParams.localStorage,
  });

  const propertyAriRequestParams =
    getFromSessionStorage(constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS) || {};
  propertyAriRequestParams[propertyTicker] = ARIRequestParams && ARIRequestParams.sessionStorage;

  saveToSessionStorage(
    constants.LOCAL_STORAGE_KEYS.PROPERTY_ARI_REQUEST_PARAMS,
    propertyAriRequestParams
  );

  return ARIRequestParams;
}

function getMetaFromChannel(channel) {
  if (!channel) {
    return "NONE";
  }
  if (channel.toLowerCase().includes(constants.CHANNEL.GOOGLE)) {
    return constants.METASEARCH.GOOGLE;
  }
  if (channel.toLowerCase().includes(constants.CHANNEL.TRIPADVISOR)) {
    return constants.METASEARCH.TRIPADVISOR;
  }
  if (channel.toLowerCase().includes(constants.CHANNEL.TRIVAGO)) {
    return constants.METASEARCH.TRIVAGO;
  }
  return "NONE";
}
function getLargestDiscount({ ARI, propertyTicker }) {
  const ariValues = ARI && ARI[propertyTicker] && ARI[propertyTicker].arivalues;
  if (!ariValues) {
    return undefined;
  }
  const discounts = Object.values(ariValues).map(({ discountAmount }) =>
    discountAmount ? discountAmount : 0
  );
  const maxDiscount = Math.max(...discounts);
  return maxDiscount > 0 ? maxDiscount : undefined;
}

function getOccupantOrZero(ariRequestParams, occupantType) {
  return parseInt(ariRequestParams[occupantType]) || 0;
}

export function buildQueryTrackData({ ARI, ariRequestParams, configuration, propertyTicker }) {
  return removeUndefinedOrNullProps({
    createdAt: new Date(),
    defaultQuery: configuration.isDefaultQuery,
    checkin: ariRequestParams.start,
    checkout: ariRequestParams.end,
    totalNumberOfOccupants:
      getOccupantOrZero(ariRequestParams, "seniors") +
      getOccupantOrZero(ariRequestParams, "adults") +
      getOccupantOrZero(ariRequestParams, "teenagers") +
      getOccupantOrZero(ariRequestParams, "children") +
      getOccupantOrZero(ariRequestParams, "babies"),
    seniors: parseInt(ariRequestParams.seniors) ? parseInt(ariRequestParams.seniors) : undefined,
    adults: parseInt(ariRequestParams.adults),
    teenagers:
      parseInt(ariRequestParams.teenagers) !== 0 ? parseInt(ariRequestParams.teenagers) : undefined,
    children:
      parseInt(ariRequestParams.children) !== 0 ? parseInt(ariRequestParams.children) : undefined,
    babies: parseInt(ariRequestParams.babies) !== 0 ? parseInt(ariRequestParams.babies) : undefined,
    lowestRate:
      ARI &&
      ARI[propertyTicker] &&
      ARI[propertyTicker].arivalues &&
      ARI[propertyTicker].arivalues[propertyTicker] &&
      ARI[propertyTicker].arivalues[propertyTicker].totalRate,
    highestDiscount: getLargestDiscount({ propertyTicker, ARI }),
  });
}

function trackEngineData({ propertyTicker, configuration, ARI, ariRequestParams }) {
  const initialEngineData = removeUndefinedOrNullProps({
    propertyTicker,
    affiliate: configuration.affiliate,
    aggregate: ARI[propertyTicker]["type"] === constants.PROPERTY_TYPE.CHAIN,
    currency: configuration.currency,
    device: configuration.deviceInfo.deviceType,
    locale: configuration.locale,
    metaChannel: getMetaFromChannel(configuration.channel),
    os: configuration.deviceInfo.osName,
    userAgent: navigator.userAgent,
  });

  const initialQuery = buildQueryTrackData({
    ARI,
    ariRequestParams,
    configuration,
    propertyTicker,
  });

  const initialIpInfo = {
    ip: configuration.ipInfo.ip,
    country: configuration.ipInfo.country,
    cityName: configuration.ipInfo.cityName,
  };

  initEngineDataCollector(initialEngineData, initialQuery, initialIpInfo).then(() =>
    console.debug("successfully tracked")
  );
}
export async function fetchBookingEngineData(params, dispatch, sessionData) {
  const propertyTicker = params.hotelTicker;
  try {
    if (!propertyTicker) {
      throw new Error("BAD ENGINE CONFIGURATION. MISSING_TICKER ");
    }
    let configuration = null;
    let ARIRequestParams;
    const ipInfo = await getIPInfo();
    return buildConfiguration({ urlParams: params, ipInfo, sessionData: sessionData || {} })
      .then(async configurationResponse => {
        configuration = configurationResponse;
        const occupationAlternatives = configuration.showOccupationAlternatives;
        ARIRequestParams = saveAriParamsToStorage(configuration, propertyTicker);
        const sessionId = sessionData && sessionData.id;
        return Promise.all([
          fetchPropertyData(propertyTicker, configuration.locale, sessionId),
          fetchARI(propertyTicker, {
            ...ARIRequestParams.localStorage,
            ...ARIRequestParams.sessionStorage,
            ipInfo: configuration.ipInfo,
            session: sessionData,
            sessionId,
          }),
          occupationAlternatives &&
          occupationAlternatives !== constants.SHOW_OCCUPATION_ALTERNATIVES.HIDE
            ? fetchARI(propertyTicker, {
                ...ARIRequestParams.localStorage,
                ...ARIRequestParams.sessionStorage,
                ipInfo: configuration.ipInfo,
                ignoredConfiguration: true,
                session: sessionData,
                sessionId,
              })
            : Promise.resolve(null),
        ]);
      })
      .then(([propertyData, ARI, ARIAll]) => {
        trackEngineData({
          propertyTicker,
          configuration,
          ARI,
          ariRequestParams: {
            ...ARIRequestParams.localStorage,
            ...ARIRequestParams.sessionStorage,
          },
        });
        return dispatch(changeLocaleIntl(configuration.locale)).then(() => ({
          configuration,
          propertyData,
          ARI,
          ARIAll,
          propertyTicker,
        }));
      })
      .catch(err => {
        console.log("An error ocurred getting the configuration1 " + err);
        throw err;
      });
  } catch (err) {
    console.log("An error ocurred getting the configuration2 " + err);
    throw err;
  }
}

export default {
  buildARIRequestParams,
  fetchARI,
};
